import { isUploadedImage } from '@prezly/uploads';
import { Element } from "../Element.mjs";
import { isBoolean, isEnum } from "../validation/index.mjs";
export var ImageNode;

(function (ImageNode) {
  ImageNode.TYPE = 'image-block';
  var Layout;

  (function (Layout) {
    Layout["CONTAINED"] = "contained";
    Layout["EXPANDED"] = "expanded";
    Layout["FULL_WIDTH"] = "full-width";
  })(Layout = ImageNode.Layout || (ImageNode.Layout = {}));

  var WIDTH_REGEX = /^\d+(\.\d+)?(px|%)$/;

  function isImageNode(value) {
    return Element.isElement(value, ImageNode.TYPE);
  }

  ImageNode.isImageNode = isImageNode;

  function validateImageNode(value) {
    var isValid = isImageNode(value) && (value.href === null || typeof value.href === 'string') && isBoolean(value.new_tab) && isEnum(value.layout, Layout) && isUploadedImage(value.file) && typeof value.width === 'string' && WIDTH_REGEX.test(value.width);
    return isValid ? value : null;
  }

  ImageNode.validateImageNode = validateImageNode;
})(ImageNode || (ImageNode = {}));